import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ridango-ui-sort-button',
    templateUrl: './sort-button.component.html',
    styleUrls: ['./sort-button.component.scss'],
})
export class SortButtonComponent {
    @Input() descOrder: boolean;
    @Output() onClick = new EventEmitter<boolean>();

    changeSortOrder() {
        // this line is needed when descOrder input is not provided from parent component
        this.descOrder = !this.descOrder;
        this.onClick.emit(this.descOrder);
    }
}
